import React from "react";
import PropTypes from "prop-types";

import DoubleArrow from "./doublearrow";

const Pick = ({ description, link }) => {
  return (
    <a className="editorPicksLink" href={link}>
      <div className="editorPickDiv">
        <div className="editorPickLayout">
          <span className="editorPickTitle">{description}</span>
          <DoubleArrow />
        </div>
      </div>
    </a>
  );
};

Pick.propTypes = {
  description: PropTypes.string,
  link: PropTypes.string
};

export default Pick;
